var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 12.25C12.6875 7.66675 16.4167 3.9375 21 3.9375C25.5832 3.9375 29.3125 7.66675 29.3125 12.25C29.3125 16.8333 25.5832 20.5625 21 20.5625C16.4167 20.5625 12.6875 16.8333 12.6875 12.25ZM26.25 23.1875H15.75C10.2025 23.1875 5.6875 27.7025 5.6875 33.25C5.6875 35.9048 7.84525 38.0625 10.5 38.0625H31.5C34.1547 38.0625 36.3125 35.9048 36.3125 33.25C36.3125 27.7025 31.7975 23.1875 26.25 23.1875Z",
    fill: "#6C5EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDashboard);
export default __webpack_public_path__ + "static/media/User-Dashboard.3a2bc3345995dc7fa911804f6d6f925a.svg";
export { ForwardRef as ReactComponent };